/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type GenerateUniquePrefixInput = {
    name?: string | null | undefined;
    domain?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type generateUniquePrefixMutationVariables = {
    input: GenerateUniquePrefixInput;
};
export type generateUniquePrefixMutationResponse = {
    readonly generateUniquePrefix: {
        readonly prefix: string | null;
    } | null;
};
export type generateUniquePrefixMutation = {
    readonly response: generateUniquePrefixMutationResponse;
    readonly variables: generateUniquePrefixMutationVariables;
};



/*
mutation generateUniquePrefixMutation(
  $input: GenerateUniquePrefixInput!
) {
  generateUniquePrefix(input: $input) {
    prefix
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "GenerateUniquePrefixInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateUniquePrefixPayload",
    "kind": "LinkedField",
    "name": "generateUniquePrefix",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "prefix",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "generateUniquePrefixMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "generateUniquePrefixMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "generateUniquePrefixMutation",
    "operationKind": "mutation",
    "text": "mutation generateUniquePrefixMutation(\n  $input: GenerateUniquePrefixInput!\n) {\n  generateUniquePrefix(input: $input) {\n    prefix\n  }\n}\n"
  }
};
})();
(node as any).hash = 'a76f71f64bea2de03b50316f27bec514';
export default node;
